import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from "react-helmet"
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"

const UpdateLogoVersion = ({ imgData }) => {
  const data = useStaticQuery(graphql`
    query UpdateLogoVersionQuery {      
      imageBg: file(relativePath: { eq: "logo/new-command-access-logo.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 300
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  const catLogo = getImage(data.imageBg)
  const catLogoSrc = getSrc(imgData ? imgData : catLogo)

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={catLogoSrc} />
      </Helmet>

      <GatsbyImage
        image={imgData ? imgData : catLogo}
        width="100%"
        quality="95"
        alt="Command Access logo"
      />
    </>
  )
}

export default UpdateLogoVersion